<app-section-header [title]="'Preguntas más comunes (F.A.Q.)'"></app-section-header>

<!--
<div class="section-wrapper buttons buttons-left">
    <span class="section-title">
        <button mat-mini-fab class="btn-1">
            <mat-icon>admin_panel_settings</mat-icon>
        </button> Qué son los roles
    </span>

    <div class="section-text">
        Cada usuario logueado tiene un rol asociado dentro de la web, que le permite hacer más o menos acciones, para una mejor gestión del contenido:
        <ul>
            <li><b>Un usuario LECTOR</b> tiene perfil propio y eso le permite suscribirse a ciertos eventos o entidades para recibir información.
            </li>
            <li><b>Un usuario AUTOR</b>, además de tener perfil propio, puede crear eventos para las entidades que representa, y para lo cual un ADMIN le ha dado permisos.
            </li>
            <li><b>Un usuario ADMIN</b> asegura un buen funcionamiento de la web dando permisos a los usuarios para gestionar sus propias entidades, y organiza los lugares, categorías, noticias o avisos que también forman parte del web.
            </li>
        </ul>
    </div>

    <mat-divider></mat-divider>

    <span class="section-subtitle">
        <button mat-mini-fab class="btn-1">
            <mat-icon>refresh</mat-icon>
        </button> Actualizar la aplicación
    </span>

    <div class="section-text">
        Actualmente estás usando la versión {{ appVersion }} desplegada el {{ releaseDate }} con {{ angularVersion }}
    </div>

    <div class="buttons buttons-center">
        <button mat-fab class="btn-extra" (click)="updatePwa()">
            <mat-icon>update</mat-icon>
        </button>
    </div>

    <div class="section-text">
        Para forzar la actualización de la aplicación, haz click en este botón de arriba.
    </div>

    <mat-divider></mat-divider>

    <span class="section-subtitle">
        <button mat-mini-fab class="btn-1">
            <mat-icon>call</mat-icon>
        </button> Cómo puedo contactar con la web
    </span>

    <div class="section-text">
        TODO
    </div>

    <mat-divider></mat-divider>
</div>
 -->
